<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="main-faqs">
            <h1><p>PERGUNTAS<br>
                FREQUENTES</p></h1>
        </div>
        <div class="faqs">
            <div class="accordion max-width ">
                <mat-accordion>
                    <mat-expansion-panel hideToggle *ngFor="let faq of faqs" class="cont">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <img src='assets/images/icon_abrir-faq.png' alt='' class="open">
                                <img src='assets/images/icon_cerrar-faq.png' alt='' class="close">
                                <p>{{faq.question}}</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="description" [innerHTML]='faq.description'></p>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container" #contenedorMovil>

            <div class="box-img">
                <img class="img-prin">
            </div>

            <div class="content-res">
                <h1><p class="title">Perguntas<br><span>Frequentes</span></p></h1>
            </div>

            <mat-accordion>
                <mat-expansion-panel hideToggle *ngFor="let faq of faqs" class="cont">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <p><span>{{faq.question}}</span></p>
                            <img src='assets/images/m/arrowdown.png' alt='' class="open">
                            <img src='assets/images/m/arrowup.png' alt='' class="close">
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="content">
                        <p class="text" [innerHTML]='faq.description'></p>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

        </div>
    </div>

</app-template>
